// Life & Wealth Solutions V6 - Main Layout Component
// Phoenix Rescue Apps - Application Shell

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const MainLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />

      {/* Main Content Area */}
      <div className={`flex flex-col flex-1 transition-all duration-300 ${sidebarOpen ? 'lg:ml-64' : 'lg:ml-16'}`}>
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />

        {/* Page Content */}
        <main className="flex-1 p-6">
          <Outlet />
        </main>

        {/* Footer — legal links, patent pending, visible on every page */}
        <footer className="border-t border-gray-200 bg-white px-6 py-3 flex items-center justify-between text-xs text-gray-400">
          <span>&copy; 2026 Phoenix Rescue Apps, LLC. Patent Pending.</span>
          <div className="flex gap-4">
            <a href="/terms.html" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600">Terms</a>
            <a href="/msa.html" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600">MSA</a>
            <a href="/privacy.html" target="_blank" rel="noopener noreferrer" className="hover:text-gray-600">Privacy</a>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default MainLayout;
